import BaseTransitionConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/base';
import { DeepReadonly } from 'ts-essentials';
import { ICTSlideTransition } from '@tencent/slide-sdk-pb-model';
import {
    INewsflashTransition,
} from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { DeepPartial } from '@src/slide/infrastructure/module/independent/ts-tools/deep-partial';

export default class NewsflashConverter extends BaseTransitionConverter {
    public convertPartialSdkToUi(
        sdkData: DeepReadonly<ICTSlideTransition>,
        uiData: INewsflashTransition,
    ) {
        super.convertPartialSdkToUi(sdkData, uiData);
    }

    public convertPartialUiToSdk(uiData: DeepPartial<INewsflashTransition>, sdkData: ICTSlideTransition) {
        super.convertPartialUiToSdk(uiData, sdkData);

        // 这里在sdk中只是一个bool类型，而不会涉及到这个字段的修改。这里只负责在从其他类型到newsflash的转换中，新增newsflash字段设置为true，不涉及对此字段的改动
        const sdkNewsflash = sdkData.newsflash || true;

        sdkData.newsflash = sdkNewsflash;
    }
}
